import { Pipe, PipeTransform } from '@angular/core';
import { LOG } from 'src/app/common/util/log';
import { GermanToCountryCode } from './country-translations';
import { BoTable } from 'src/openapi-client/model/boTable';

type Renderable = any;

function isBoTable(renderable?: Renderable): boolean {
  return !!renderable && 'rows' in renderable;
}

export type CountryData = {
  data: Array<[string, number]>;
  bmk?: Array<number>;
  labels: Array<string>;
};

@Pipe({
  name: 'tableToCountryData',
  standalone: true,
})
export class TableToCountryPipe implements PipeTransform {
  transform(table: BoTable): CountryData | undefined {
    if (!isBoTable(table) || table.rows.length < 1) {
      return undefined;
    }

    const result: CountryData = {
      data: [],
      labels: [],
    };

    const hasBmk: boolean = table.rows[0].cells.length > 2;

    if (hasBmk) {
      result.bmk = [];
    }

    for (const row of table.rows) {
      const country: string = row.cells[0].content!;
      const key: string | undefined = (GermanToCountryCode as any)[country]?.toLowerCase();

      if (!key) {
        LOG.debug('Unknown country:', country);
        continue;
      }

      const value: number = Number.parseFloat(row.cells[1].content!.replace(',', '.'));
      result.data.push([key, value]);
      result.labels.push(country);

      if (hasBmk) {
        const bmk: number = Number.parseFloat(row.cells[2].content!.replace(',', '.'));
        result.bmk!.push(bmk);
      }
    }

    return result;
  }
}
